var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"flat":"","color":"vCardColor"}},[_c('v-card-text',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',[_c('v-col',[_vm._v(_vm._s(_vm.$t("LOGINRECOVERY.HELP.secondaryEmail")))]),_c('v-col',[_vm._v(_vm._s(_vm.$t("LOGINRECOVERY.HELP.secretariat")))])],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }